export default __webpack_public_path__ + "static/media/FastWaterMarks.ad52a5d1.svg";